import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom"; // Updated imports for React Router v6
import { useDispatch } from "react-redux";

// MUI components
import { Box } from "@mui/material";
// core components
import Layout from "../../core/Layout";
import resources from "../../core/Localization/Localization.js";
import Button from "../../components/CustomButtons/Button.js";
//common
import { TransactionTypes } from "../../common/transactions/config";
//utils
import finance from "../../core/Localization/finance";
import TransactionsTable from "./TransactionsTable";

export default function Transactions() {
    const navigate = useNavigate(); // Replacing useHistory with useNavigate
    const location = useLocation(); // Replacing history.location with useLocation

    const historyState = location.state; // Extracting state from location

    // Store hooks
    const dispatch = useDispatch();

    // State hooks
    const [type, setType] = React.useState(TransactionTypes.PAYIN);

    // React hooks
    useEffect(() => {
        if (Object.values(TransactionTypes).includes(historyState)) {
            setType(historyState);
        }
    }, [historyState]);

    // Private (helper) functions
    const handleTabChange = (type) => {
        setType(type);
    };

    return (
        <Layout>
            <Box sx={{ padding: 1 }}>
                <Box>
                    <Button
                        onClick={() => handleTabChange(TransactionTypes.PAYIN)}
                        color={type === finance.en.finance.type.payin.toLowerCase() ? "success" : "error"}
                        sx={{ marginRight: 3 }}
                    >
                        {resources.finance.type.payin}
                    </Button>
                    <Button
                        onClick={() => handleTabChange(TransactionTypes.CHARGE)}
                        color={type === finance.en.finance.type.charge.toLowerCase() ? "success" : "error"}
                        sx={{ marginRight: 3 }}
                    >
                        {resources.finance.type.charge}
                    </Button>
                    <Button
                        onClick={() => handleTabChange(TransactionTypes.RESERVED)}
                        color={type === finance.en.finance.type.reserved.toLowerCase() ? "success" : "error"}
                        sx={{ marginRight: 3 }}
                    >
                        {resources.finance.type.reserved}
                    </Button>
                    <Button
                        onClick={() => handleTabChange(TransactionTypes.CORRECTION)}
                        color={type === finance.en.finance.type.correction.toLowerCase() ? "success" : "error"}
                        sx={{ marginRight: 3 }}
                    >
                        {resources.finance.type.correction}
                    </Button>
                </Box>
                <TransactionsTable type={type} />
            </Box>
        </Layout>
    );
}
